/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForKubernetesCluster extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForKubernetesCluster");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForKubernetesCluster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForKubernetesCluster>): ServiceAccountCredentialsBaseForKubernetesCluster {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForKubernetesCluster(), model);
        ServiceAccountCredentialsBaseForKubernetesCluster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForKubernetesCluster>): ServiceAccountCredentialsBaseForKubernetesCluster {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForKubernetesCluster.newInstance(<ServiceAccountCredentialsBaseForKubernetesCluster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForKubernetesCluster) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForKubernetesCluster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForKubernetesCluster): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForKubernetesCluster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
